// extracted by mini-css-extract-plugin
export default {"root":"textarea_root__v4H2Q","root__label":"textarea_root__label__nVWim","root__label_full":"textarea_root__label_full__+xn7J"};